import { Camera, Check, Plus, RefreshCw, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { layerComps } from '../core/layer-comps';
import type { EditorDocument } from '../core/model';
import type { DocumentSession } from '../core/session';
import { runCommand } from '../semantic/commands/run';

export function LayerCompsPanel({ document, session }: { document: EditorDocument; session: DocumentSession }) {
  const [name, setName] = useState('');
  const comps = layerComps(document);
  const save = () => {
    runCommand(session, 'layerComps.save', { name });
    setName('');
  };
  return <section className="layer-comps-panel">
    <h4><Camera size={14} /> Layer comps <span>{comps.length}</span></h4>
    <div className="layer-comp-create">
      <input value={name} placeholder={`Comp ${comps.length + 1}`} aria-label="Layer comp name" onChange={(event) => setName(event.target.value)} onKeyDown={(event) => {
        if (event.key === 'Enter') save();
      }} />
      <button type="button" title="Save current visibility, position, and appearance" onClick={save}><Plus size={14} /></button>
    </div>
    {comps.length === 0 ? <p>Save visibility, position, opacity, and blend states to compare layout variations.</p> : <div className="layer-comp-list">
      {comps.map((comp) => <div className="layer-comp-row" key={comp.id}>
        <button type="button" className="layer-comp-apply" onClick={() => runCommand(session, 'layerComps.apply', { comp: comp.id })}><Check size={13} />{comp.name}</button>
        <button type="button" title="Update from current document" onClick={() => runCommand(session, 'layerComps.update', { comp: comp.id })}><RefreshCw size={12} /></button>
        <button type="button" title="Delete comp" onClick={() => runCommand(session, 'layerComps.delete', { comp: comp.id })}><Trash2 size={12} /></button>
      </div>)}
    </div>}
  </section>;
}
